export default {
  // Detected Risks Page
  'service_detected_risks.page.title.name': 'Detected Risks',
  // Detected Risks List
  'service_detected_risks.list.headers.risk_name': 'Risk Name',
  'service_detected_risks.list.headers.description': 'Description',
  'service_detected_risks.list.headers.status': 'Status',
  'service_detected_risks.list.status.at_risk': 'At Risk',
  'service_detected_risks.list.status.mitigated': 'Mitigated',
  'service_detected_risks.list.status.not_applicable': 'n/a'
}
